// MainFormDigi.jsx

import React, { useState } from "react";
import "./style.css";
import "../../assets/css/candidate-tab-form.css";
import SingleTab from "../../UI_Design/SingleTab/SingleTab";
import Education1 from "./Education/Education1";
import Education2 from "./Education/Education2";
import Education3 from "./Education/Education3";

const MainFormDigi = () => {
  const [activeTab, setActiveTab] = useState(0);

  const handleContinue = () => {
    // Check if all required fields in the current tab are filled
    const currentTab = tabs[activeTab].content;
    const allFieldsFilled =
      currentTab.props.value &&
      Object.values(currentTab.props.value).every((val) => val.trim() !== "");

    if (allFieldsFilled) {
      // Move to the next tab
      setActiveTab((prevTab) => prevTab + 1);
    } else {
      // Show an error message or highlight the unfilled fields
      alert("Please fill out all fields before continuing.");
    }
  };

  const value = {
    // Define your value object here
    // For example:
    school: "Your School Name",
    degree: "Your Degree",
    fieldOfStudy: "Your Field of Study",
    startDate: "Your Start Date",
    endDate: "Your End Date",
  };

  const tabs = [
    { label: "Education 1", content: <Education1 value={value} /> },
    { label: "Education 2", content: <Education2 /> },
    { label: "Education 3", content: <Education3 /> },
  ];

  return (
    <>
      <div className="container-fluid w-100 p-2">
        <div className="headSection">
          <div className="d-flex justify-content-between align-items-start px-3">
            <div className="headings">
              <div className="head">Education</div>
              <div className="subHead">
                Add your highest education degree/certificate/all marksheets
              </div>
            </div>
            <div className="btn btn-primary" onClick={handleContinue}>
              + Add Qualification
            </div>
          </div>
          <SingleTab tabs={tabs} activeTab={activeTab} />
        </div>
      </div>
    </>
  );
};

export default MainFormDigi;
